module.exports = __webpack_public_path__ + "static/media/Food_BG.4da49d9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/png/food-store/Food_BG.png
// module id = 514
// module chunks = 0